import type { GridApi } from 'ag-grid-community';

/** Sum displayed column widths until `anchorField` (by field or colId). */
export const computeDetailPanelLeftOffset = (
  api: GridApi | null | undefined,
  anchorField: string,
  fallback = 0
) => {
  if (!api?.getAllDisplayedColumns) {
    return fallback;
  }

  const columns = api.getAllDisplayedColumns();
  let offset = 0;

  for (const column of columns) {
    const { field, colId } = column.getColDef?.() ?? {};
    if (field === anchorField || colId === anchorField) {
      return offset;
    }
    offset += column.getActualWidth?.() ?? 0;
  }

  return offset || fallback;
};
